import apiService from './apiService'

const CashRegisterService = {
    async getCashRegisters(params = {}) {
        try {
            const response = await apiService.get('/cash-registers', params)
            return response.data
        } catch (error) {
            throw apiService.formatError(error)
        }
    },

    async openCashRegister(data) {
        try {
            const response = await apiService.post('/cash-registers/open', data)
            return response.data
        } catch (error) {
            throw apiService.formatError(error)
        }
    },

    async closeCashRegister(data) {
        try {
            const response = await apiService.post('/cash-registers/close', data)
            return response.data
        } catch (error) {
            throw apiService.formatError(error)
        }
    },

    /**
     * {
        "status": "success",
        "data": {
            "cash_register": {
            "id": 1,
            "status": "open",
            "start_date": "2025-01-01T00:00:00",
            "end_date": null,
            "start_balance": 0.00,
            "end_balance": 0.00
            },
            "statistics": {
            "total_sales": 150,
            "completed_sales": 145,
            "pending_sales": 5,
            "ca_ht": 1500000.00,
            "ca_ttc": 1800000.00,
            "ca_cash": 1200000.00,
            "ca_deferred": 600000.00,
            "cash_sales_count": 100,
            "deferred_sales_count": 45
            }
        }
        }
     * @param {*} id 
     * @returns 
     */
    async getCashRegisterStats(id) {
        try {
            const response = await apiService.get(`/cash-registers/${id}/stats`);
            return response.data;
        } catch (error) {
            throw apiService.formatError(error);
        }
    },

    /**
     * Génère et télécharge une fiche de ventes pour une caisse spécifique.
     * @param {number|string} id - L'identifiant de la caisse.
     * @param {Object} payload - Les données nécessaires à la génération de la fiche (le cas échéant).
     * @returns {Promise<Blob>} Le fichier de la fiche de ventes (généralement un PDF)
     */
    async generateSalesSheet(id, payload = {}) {
        try {
            const response = await apiService.post(
                `/cash-registers/${id}/sales-sheet`,
                payload,
                { responseType: 'blob' }
            );
            return response.data;
        } catch (error) {
            throw apiService.formatError(error);
        }
    },

    /**
     * Fetch the cash register currently opened by the logged-in user.
     * GET /cash-registers/my-opened
     * @returns {Promise<Object>} The opened cash register data
     */
    async getMyOpenedCashRegister() {
        try {
            const response = await apiService.get('/cash-registers/my-opened');
            return response.data;
        } catch (error) {
            throw apiService.formatError(error);
        }
    },


    hasOpenedCashRegister() {
        return localStorage.getItem('cashRegister') !== null;
    },

    getOpenedCashRegister() {
        return JSON.parse(localStorage.getItem('cashRegister'));
    },

    removeOpenedCashRegister() {
        localStorage.removeItem('cashRegister');
        window.location.reload();
    },

    /**
     * Save the current opened cash register object to localStorage.
     * @param {Object} cashRegister - The opened cash register object to store.
     */
    async pullAndSaveOpenedCashRegister() {
        try {
            const response = await this.getMyOpenedCashRegister();
            localStorage.setItem('cashRegister', JSON.stringify(response.data));
            return response.data;
        } catch (error) {
            localStorage.removeItem('cashRegister');
            console.error('Erreur lors de la récupération de la caisse ouverte:', error);
        }
    },

    async printSalesSheet(cashRegisterId, open = false) {
        try {
            const response = await this.generateSalesSheet(cashRegisterId);
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            if (open) {
                // Ouvrir dans un nouvel onglet pour prévisualisation
                window.open(url, '_blank');
            } else {
                // Télécharger directement
                const link = document.createElement('a');
                link.href = url;
                link.download = `fiche-de-ventes-${cashRegisterId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            // Nettoyer l'URL après un délai pour permettre l'ouverture
            setTimeout(() => window.URL.revokeObjectURL(url), 100);
        } catch (error) {
            throw apiService.formatError(error);
        }
    },

    async downloadReport(cashRegisterId) {
        try {
            const response = await apiService.post(`/cash-registers/${cashRegisterId}/report`, {}, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = `rapport-caisse-${cashRegisterId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => window.URL.revokeObjectURL(url), 100);
        } catch (error) {
            throw apiService.formatError(error);
        }
    },

    async downloadSalesSheetWithProducts(cashRegisterId) {
        try {
            const response = await apiService.post(`/cash-registers/${cashRegisterId}/sales-sheet-products`, {}, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = `fiche-ventes-produits-${cashRegisterId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => window.URL.revokeObjectURL(url), 100);
        } catch (error) {
            throw apiService.formatError(error);
        }
    },
}



export default CashRegisterService

